import { propOr } from 'ramda'

import { PersonalizationType, SinglePersonalizationType } from '@/app/types'

export const wrapBrackets = (text: string) => `[${text}]`

export const wrapEachBrackets = (text: string = '') => text.split('').map(wrapBrackets).join('')

export const generatePattern = (pzMap: SinglePersonalizationType[], shouldEscape = false) =>
  pzMap
    .map(({ label }) => `${shouldEscape ? '\\{\\{' : '{{'}${wrapEachBrackets(label)}${shouldEscape ? '\\}\\}' : '}}'}`)
    .join('|')

export const pzListToArray = (pzList: PersonalizationType) => Object.values(pzList).flatMap((items) => items ?? [])

export const addCurlyBrackets = (text: string) => `{{${text}}}`

export const removeCurlyBrackets = (text: string) => text.replace(/{{|}}/g, '')

export const transformFromPersonalization = (
  value: string,
  pzMap: Record<string, SinglePersonalizationType>,
  transformMatch?: (match: string) => string,
) => transform(value, pzMap, 'label', transformMatch)

export const transformToPersonalization = (
  value: string,
  pzMap: Record<string, SinglePersonalizationType>,
  transformMatch?: (match: string) => string,
) => transform(value, pzMap, 'value', transformMatch)

const transform = (
  value: string,
  pzMap: Record<string, SinglePersonalizationType>,
  attribute: string,
  transformMatch?: (match: string) => string,
) =>
  value.replace(/\{\{(.*?)\}\}/g, (_, match) => {
    const matchString: string = transformMatch ? transformMatch(match) : match
    const foundPersonalization = propOr({}, matchString, pzMap)
    return `{{${propOr(match, attribute, foundPersonalization)}}}`
  })
